<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="500px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="share-login-dialog no-header body-no-padding"
  >
    <div class="login-content">
      <i class="el-icon-close icon-close" @click="handleClose" />
      <div class="sign-in-title">
        <img src="@/assets/img/logo.svg" height="30" alt="" />
      </div>
      <iframe
        id="shareLoginIframe"
        :src="iframeUrl"
        frameborder="0"
        width="100%"
        height="428px"
      >
      </iframe>
      <img src="@/assets/img/zhiditu@2x.png" class="huo-dong-tu" height="100" @click="toHelp" alt="" />
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import checkLoginMixin from '@/mixins/checkLoginMixin'
import openUrlMixin from '@/mixins/openUrlMixin'

export default {
  name: 'ShareLoginDialog',
  mixins: [checkLoginMixin, openUrlMixin],
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      platform: 'platform',
      getConfig: 'staticConfig/getConfig',
    }),
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    iframeUrl() {
      return `${process.env.VUE_APP_GJW_PORTAL_URL}/signinForTeam?dest=${encodeURIComponent(window.location.href)}&platform=${this.platform}`
    },
    introUrl() {
      const linkUrls = this.getConfig('linkUrls') || {}
      return linkUrls.introUrl || ''
    },
  },
  mounted() {
    window.addEventListener('message', this.receiveMessage, false)
  },
  beforeDestroy() {
    // 移除事件监听, 防止重复触发
    window.removeEventListener('message', this.receiveMessage, false)
  },
  methods: {
    async receiveMessage(event) {
      if (!event.data || typeof event.data !== 'string') {
        return
      }
      const origin = event.origin
      if (origin !== process.env.VUE_APP_GJW_PORTAL_URL) {
        return
      }
      const data = JSON.parse(event.data) || {}
      if (data.login) {
        // 获取用户信息
        if (await this.checkLogin(data.token)) {
          this.$message.success('登录成功')
          this.dialogVisible = false
          // 通知父组件登录成功
          this.$emit('login-success')
        }
      }
      // 打开外链
      if (data.openLink) {
        this.openUrl(data.url)
      }
    },
    toHelp() {
      const url = this.introUrl
      if (!url) { return }
      if (this.platform === 'web') {
        window.open(url, '_blank')
      } else {
        this.$desktopClient.NavigateToBrowser(url)
      }
    },
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>

<style lang="less">
.share-login-dialog {
  .login-content {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .icon-close{
    font-size: 18px;
    cursor: pointer;
    position: absolute;
    right: 6px;
    top: 10px;
  }
  .sign-in-title{
    margin-top: 20px;
  }
  .huo-dong-tu{
    width: 100%;
    height:100px;
    cursor: pointer;
    margin-top: -72px;
  }
}
</style>

